module.exports = {
	"contractName": "StrongBox",
	"abi": [
		{
			"constant": true,
			"inputs": [],
			"name": "guardLib",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
				{
					"name": "_guardLibrary",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "constructor"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "pass",
			"outputs": [
				{
					"name": "",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		}
	],
	"bytecode": "0x608060405234801561001057600080fd5b50604051602080610209833981016040525160008054600160a060020a03909216600160a060020a03199092169190911790556101b7806100526000396000f30060806040526004361061004b5763ffffffff7c0100000000000000000000000000000000000000000000000000000000600035041663696798fd8114610050578063a7a1ed721461008e575b600080fd5b34801561005c57600080fd5b506100656100b7565b6040805173ffffffffffffffffffffffffffffffffffffffff9092168252519081900360200190f35b34801561009a57600080fd5b506100a36100d3565b604080519115158252519081900360200190f35b60005473ffffffffffffffffffffffffffffffffffffffff1681565b60008060009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1663522e11776040518163ffffffff167c0100000000000000000000000000000000000000000000000000000000028152600401602060405180830381600087803b15801561015a57600080fd5b505af115801561016e573d6000803e3d6000fd5b505050506040513d602081101561018457600080fd5b50519050905600a165627a7a723058207696e450f6204c258cb911363f5d590935c567a26c1cb600bcf92a2f4dcb01b90029",
	"deployedBytecode": "0x60806040526004361061004b5763ffffffff7c0100000000000000000000000000000000000000000000000000000000600035041663696798fd8114610050578063a7a1ed721461008e575b600080fd5b34801561005c57600080fd5b506100656100b7565b6040805173ffffffffffffffffffffffffffffffffffffffff9092168252519081900360200190f35b34801561009a57600080fd5b506100a36100d3565b604080519115158252519081900360200190f35b60005473ffffffffffffffffffffffffffffffffffffffff1681565b60008060009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1663522e11776040518163ffffffff167c0100000000000000000000000000000000000000000000000000000000028152600401602060405180830381600087803b15801561015a57600080fd5b505af115801561016e573d6000803e3d6000fd5b505050506040513d602081101561018457600080fd5b50519050905600a165627a7a723058207696e450f6204c258cb911363f5d590935c567a26c1cb600bcf92a2f4dcb01b90029",
	"sourceMap": "77:228:22:-;;;128:77;8:9:-1;5:2;;;30:1;27;20:12;5:2;128:77:22;;;;;;;;;;;;;176:8;:24;;-1:-1:-1;;;;;176:24:22;;;-1:-1:-1;;;;;;176:24:22;;;;;;;;;77:228;;;;;;",
	"deployedSourceMap": "77:228:22:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;100:23;;8:9:-1;5:2;;;30:1;27;20:12;5:2;100:23:22;;;;;;;;;;;;;;;;;;;;;;;209:94;;8:9:-1;5:2;;;30:1;27;20:12;5:2;209:94:22;;;;;;;;;;;;;;;;;;;;;;100:23;;;;;;:::o;209:94::-;246:4;278:8;;;;;;;;;;;265:31;;;:33;;;;;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;30:1;27;20:12;5:2;265:33:22;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;265:33:22;;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;-1:-1;265:33:22;;-1:-1:-1;209:94:22;:::o",
	"source": "pragma solidity ^0.4.24;\n\ncontract GuardLibrary {\n  bool public complete;\n}\n\ncontract StrongBox {\n  address public guardLib;\n\n  constructor(address _guardLibrary) public {\n    guardLib = _guardLibrary;\n  }\n\n  function pass() public view returns (bool) {\n    return GuardLibrary(guardLib).complete();\n  }\n}\n",
	"sourcePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/StrongBox.sol",
	"ast": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/StrongBox.sol",
		"exportedSymbols": {
			"GuardLibrary": [
				2118
			],
			"StrongBox": [
				2143
			]
		},
		"id": 2144,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 2115,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".24"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:22"
			},
			{
				"baseContracts": [],
				"contractDependencies": [],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 2118,
				"linearizedBaseContracts": [
					2118
				],
				"name": "GuardLibrary",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"constant": false,
						"id": 2117,
						"name": "complete",
						"nodeType": "VariableDeclaration",
						"scope": 2118,
						"src": "52:20:22",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_bool",
							"typeString": "bool"
						},
						"typeName": {
							"id": 2116,
							"name": "bool",
							"nodeType": "ElementaryTypeName",
							"src": "52:4:22",
							"typeDescriptions": {
								"typeIdentifier": "t_bool",
								"typeString": "bool"
							}
						},
						"value": null,
						"visibility": "public"
					}
				],
				"scope": 2144,
				"src": "26:49:22"
			},
			{
				"baseContracts": [],
				"contractDependencies": [],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 2143,
				"linearizedBaseContracts": [
					2143
				],
				"name": "StrongBox",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"constant": false,
						"id": 2120,
						"name": "guardLib",
						"nodeType": "VariableDeclaration",
						"scope": 2143,
						"src": "100:23:22",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_address",
							"typeString": "address"
						},
						"typeName": {
							"id": 2119,
							"name": "address",
							"nodeType": "ElementaryTypeName",
							"src": "100:7:22",
							"typeDescriptions": {
								"typeIdentifier": "t_address",
								"typeString": "address"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 2129,
							"nodeType": "Block",
							"src": "170:35:22",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 2127,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 2125,
											"name": "guardLib",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2120,
											"src": "176:8:22",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2126,
											"name": "_guardLibrary",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2122,
											"src": "187:13:22",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"src": "176:24:22",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 2128,
									"nodeType": "ExpressionStatement",
									"src": "176:24:22"
								}
							]
						},
						"documentation": null,
						"id": 2130,
						"implemented": true,
						"isConstructor": true,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2123,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2122,
									"name": "_guardLibrary",
									"nodeType": "VariableDeclaration",
									"scope": 2130,
									"src": "140:21:22",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2121,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "140:7:22",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "139:23:22"
						},
						"payable": false,
						"returnParameters": {
							"id": 2124,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "170:0:22"
						},
						"scope": 2143,
						"src": "128:77:22",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 2141,
							"nodeType": "Block",
							"src": "252:51:22",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [],
										"expression": {
											"argumentTypes": [],
											"expression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"id": 2136,
														"name": "guardLib",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2120,
														"src": "278:8:22",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													],
													"id": 2135,
													"name": "GuardLibrary",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2118,
													"src": "265:12:22",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_contract$_GuardLibrary_$2118_$",
														"typeString": "type(contract GuardLibrary)"
													}
												},
												"id": 2137,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "265:22:22",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_GuardLibrary_$2118",
													"typeString": "contract GuardLibrary"
												}
											},
											"id": 2138,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "complete",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 2117,
											"src": "265:31:22",
											"typeDescriptions": {
												"typeIdentifier": "t_function_external_view$__$returns$_t_bool_$",
												"typeString": "function () view external returns (bool)"
											}
										},
										"id": 2139,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "265:33:22",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"functionReturnParameters": 2134,
									"id": 2140,
									"nodeType": "Return",
									"src": "258:40:22"
								}
							]
						},
						"documentation": null,
						"id": 2142,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "pass",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2131,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "222:2:22"
						},
						"payable": false,
						"returnParameters": {
							"id": 2134,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2133,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 2142,
									"src": "246:4:22",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 2132,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "246:4:22",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "245:6:22"
						},
						"scope": 2143,
						"src": "209:94:22",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "public"
					}
				],
				"scope": 2144,
				"src": "77:228:22"
			}
		],
		"src": "0:306:22"
	},
	"legacyAST": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/StrongBox.sol",
		"exportedSymbols": {
			"GuardLibrary": [
				2118
			],
			"StrongBox": [
				2143
			]
		},
		"id": 2144,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 2115,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".24"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:22"
			},
			{
				"baseContracts": [],
				"contractDependencies": [],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 2118,
				"linearizedBaseContracts": [
					2118
				],
				"name": "GuardLibrary",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"constant": false,
						"id": 2117,
						"name": "complete",
						"nodeType": "VariableDeclaration",
						"scope": 2118,
						"src": "52:20:22",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_bool",
							"typeString": "bool"
						},
						"typeName": {
							"id": 2116,
							"name": "bool",
							"nodeType": "ElementaryTypeName",
							"src": "52:4:22",
							"typeDescriptions": {
								"typeIdentifier": "t_bool",
								"typeString": "bool"
							}
						},
						"value": null,
						"visibility": "public"
					}
				],
				"scope": 2144,
				"src": "26:49:22"
			},
			{
				"baseContracts": [],
				"contractDependencies": [],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 2143,
				"linearizedBaseContracts": [
					2143
				],
				"name": "StrongBox",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"constant": false,
						"id": 2120,
						"name": "guardLib",
						"nodeType": "VariableDeclaration",
						"scope": 2143,
						"src": "100:23:22",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_address",
							"typeString": "address"
						},
						"typeName": {
							"id": 2119,
							"name": "address",
							"nodeType": "ElementaryTypeName",
							"src": "100:7:22",
							"typeDescriptions": {
								"typeIdentifier": "t_address",
								"typeString": "address"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 2129,
							"nodeType": "Block",
							"src": "170:35:22",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 2127,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 2125,
											"name": "guardLib",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2120,
											"src": "176:8:22",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2126,
											"name": "_guardLibrary",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2122,
											"src": "187:13:22",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"src": "176:24:22",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 2128,
									"nodeType": "ExpressionStatement",
									"src": "176:24:22"
								}
							]
						},
						"documentation": null,
						"id": 2130,
						"implemented": true,
						"isConstructor": true,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2123,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2122,
									"name": "_guardLibrary",
									"nodeType": "VariableDeclaration",
									"scope": 2130,
									"src": "140:21:22",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2121,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "140:7:22",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "139:23:22"
						},
						"payable": false,
						"returnParameters": {
							"id": 2124,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "170:0:22"
						},
						"scope": 2143,
						"src": "128:77:22",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 2141,
							"nodeType": "Block",
							"src": "252:51:22",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [],
										"expression": {
											"argumentTypes": [],
											"expression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"id": 2136,
														"name": "guardLib",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2120,
														"src": "278:8:22",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													],
													"id": 2135,
													"name": "GuardLibrary",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2118,
													"src": "265:12:22",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_contract$_GuardLibrary_$2118_$",
														"typeString": "type(contract GuardLibrary)"
													}
												},
												"id": 2137,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "265:22:22",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_GuardLibrary_$2118",
													"typeString": "contract GuardLibrary"
												}
											},
											"id": 2138,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "complete",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 2117,
											"src": "265:31:22",
											"typeDescriptions": {
												"typeIdentifier": "t_function_external_view$__$returns$_t_bool_$",
												"typeString": "function () view external returns (bool)"
											}
										},
										"id": 2139,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "265:33:22",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"functionReturnParameters": 2134,
									"id": 2140,
									"nodeType": "Return",
									"src": "258:40:22"
								}
							]
						},
						"documentation": null,
						"id": 2142,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "pass",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2131,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "222:2:22"
						},
						"payable": false,
						"returnParameters": {
							"id": 2134,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2133,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 2142,
									"src": "246:4:22",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 2132,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "246:4:22",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "245:6:22"
						},
						"scope": 2143,
						"src": "209:94:22",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "public"
					}
				],
				"scope": 2144,
				"src": "77:228:22"
			}
		],
		"src": "0:306:22"
	},
	"compiler": {
		"name": "solc",
		"version": "0.4.24+commit.e67f0147.Emscripten.clang"
	},
	"networks": {},
	"schemaVersion": "2.0.1",
	"updatedAt": "2020-10-22T15:28:26.809Z"
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/StrongBox.json
// module id = 1051
// module chunks = 0